module.exports = __webpack_public_path__ + "static/media/planningBoards.983bf404.jpg";